/** YouTube IFrame PlayerState values. */
export const YT_UNSTARTED = -1;
export const YT_ENDED = 0;
export const YT_PLAYING = 1;
export const YT_PAUSED = 2;
export const YT_BUFFERING = 3;
export const YT_CUED = 5;

/**
 * Studio focus stays on for PLAYING and for BUFFERING that interrupts
 * playback. A genuine stop restores the room. Unknown states are ignored
 * so a brief unrecognized code cannot flash the lights.
 */
/**
 * How far the stage dimmer must extend, in stage pixels, to cover a visible
 * rectangle. `.VB-stage` is scaled, so `position: fixed` inside it is not
 * viewport-relative. Callers pass the visual viewport (or the clip rect)
 * and the stage's transformed border box.
 */
export function videoFocusDimExtents({ stageRect, visibleRect, scale }) {
  if (!(scale > 0) || !stageRect || !visibleRect) {
    return { left: 0, top: 0, right: 0, bottom: 0 };
  }
  const outward = (distance) => (distance > 0 ? Math.ceil(distance / scale) : 0);
  return {
    left: outward(stageRect.left - visibleRect.left),
    top: outward(stageRect.top - visibleRect.top),
    right: outward(visibleRect.right - stageRect.right),
    bottom: outward(visibleRect.bottom - stageRect.bottom),
  };
}

export function nextVideoFocusActive(current, playerState) {
  if (playerState === YT_PLAYING) return true;
  if (playerState === YT_BUFFERING) return !!current;
  if (
    playerState === YT_PAUSED ||
    playerState === YT_ENDED ||
    playerState === YT_CUED ||
    playerState === YT_UNSTARTED
  ) {
    return false;
  }
  return !!current;
}
